import React from "react";
import { connect } from "react-redux";
import { WithStyles, withStyles, Button } from "material-ui";

import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
    SetHeader,
} from "../../ducks/common";
import { RouteComponentProps, RouterProps } from "react-router";
import SwipeableViews from "react-swipeable-views";
import CreditCardDetailsPage from "./CreditCardDetailsPage";
import logger from "../../util/logger";
import ChevronLeftIcon from "material-ui-icons/ChevronLeft";
import ChevronRightIcon from "material-ui-icons/ChevronRight";
import FullPageSpinner from "../../components/FullPageSpinner/FullPageSpinner";
import { CreditCardDto } from "util/DTOs/CreditCardDtos";
import { getCreditCards } from "ducks/creaditcard";

const styles = {
    container: {
        paddingRight: 20,
        paddingLeft: 20,
        marginBottom: 60,
    },
    content: {
        height: "100%",
        padding: 16,
        position: "relative",
    },
    subheadingWeight: {
        fontWeight: "200",
    },
    centerText: {
        textAlign: "center",
    },
    rightText: {
        textAlign: "right",
    },
    flexRoot: {
        display: "flex",
        width: "calc(100% - 30px)",
        flexGrow: 1,
    },
    flexItem: {
        flex: 1,
        whiteSpace: "nowrap",
        wordWrap: "break-word",
    },
} as React.CSSProperties;

interface ICreditCardsPageProps extends RouteComponentProps<{ id?: string }> {}
interface ICreditCardsPageReduxProps {}
interface ICreditCardsPageDispatchProps {
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
}
interface ICreditCardsPageReduxProps {
    cards: CreditCardDto[];
}
interface ICreditCardsPageDispatchProps {
    getCards: () => Promise<void>;
}

interface CreditCardsPageState {
    currentIndex: number;
    loading: boolean;
}

type CreditCardsPageProps = ICreditCardsPageProps &
    ICreditCardsPageReduxProps &
    ICreditCardsPageDispatchProps &
    RouterProps;

type CreditCardsPagePropsWithStyles = CreditCardsPageProps &
    WithStyles<
        | "container"
        | "content"
        | "subheadingWeight"
        | "centerText"
        | "rightText"
        | "flexRoot"
        | "flexItem"
    >;

class CreditCardsPage extends React.Component<
    CreditCardsPagePropsWithStyles,
    CreditCardsPageState
> {
    constructor(props: CreditCardsPagePropsWithStyles) {
        super(props);
        this.state = { currentIndex: 0, loading: true };
    }
    componentDidMount() {
        this.props.setBackButton("/");
        this.props
            .getCards()
            .then(() => {
                this.setState({ ...this.state, loading: false });
            })
            .catch((err) => {
                logger.error(err);
                this.setState({ ...this.state, loading: false });
            });

        this.props.setHeaderValue("Luottokortit");
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps: CreditCardsPagePropsWithStyles) {
        if (nextProps.match.params.id) {
            let index = nextProps.cards.findIndex((item) => {
                return item.truncatedCardNumber === nextProps.match.params.id;
            });

            if (index !== -1 && this.state.currentIndex !== index) {
                this.setState({ currentIndex: index });
            }
        }
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeaderValue("");
    }

    setIndex(index: number) {
        if (this.props.match.params.id) {
            this.props.history.replace("/creditcards");
        }

        const keys = this.props.cards;
        if (
            index >= keys.length ||
            index < 0 ||
            this.state.currentIndex === index
        ) {
            return;
        }
        this.setState({ currentIndex: index, loading: false });
    }

    render() {
        const cards = this.props.cards.map((card) => {
            return (
                <CreditCardDetailsPage
                    key={card.customerCardId}
                    id={card.customerCardId}
                    {...this.props}
                />
            );
        });

        return (
            <div>
                <FullPageSpinner loading={this.state.loading} />
                {this.state.currentIndex > 0 && (
                    <div
                        id="gallery-prev-btn"
                        style={{
                            top: "59px",
                            left:
                                window.innerWidth > 960
                                    ? (window.innerWidth - 960) / 2
                                    : "0px",
                        }}
                    >
                        <Button
                            onClick={() =>
                                this.setIndex(this.state.currentIndex - 1)
                            }
                            title="Nuolipainike edellinen"
                        >
                            <ChevronLeftIcon
                                style={{
                                    height: "48px",
                                    width: "48px",
                                    color: "rgba(0,0,0,0.5)",
                                }}
                            />
                        </Button>
                    </div>
                )}
                {this.state.currentIndex < this.props.cards.length - 1 && (
                    <div
                        id="gallery-next-btn"
                        style={{
                            top: "59px",
                            right:
                                window.innerWidth > 960
                                    ? (window.innerWidth - 960) / 2
                                    : "0px",
                        }}
                    >
                        <Button
                            onClick={() =>
                                this.setIndex(this.state.currentIndex + 1)
                            }
                            title="Nuolipainike seuraava"
                        >
                            <ChevronRightIcon
                                style={{
                                    height: "48px",
                                    width: "48px",
                                    color: "rgba(0,0,0,0.5)",
                                }}
                            />
                        </Button>
                    </div>
                )}
                <SwipeableViews
                    index={this.state.currentIndex}
                    onChangeIndex={(i: number) => this.setIndex(i)}
                >
                    {(cards && cards.length > 0 && cards) || (
                        <div className="centered-message-container">
                            <h2 className="hypodgrey">EI KORTTEJA</h2>
                        </div>
                    )}
                </SwipeableViews>
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: CreditCardsPageProps
): ICreditCardsPageReduxProps => {
    return {
        cards: state.creditcard.cards || [],
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ICreditCardsPageDispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        getCards: async () => {
            await dispatch(getCreditCards());
        },
    };
};

export default connect<
    ICreditCardsPageReduxProps,
    ICreditCardsPageDispatchProps,
    ICreditCardsPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CreditCardsPage));



// WEBPACK FOOTER //
// ./src/views/creditcard/CreditCardsPage.tsx